import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import IconButton from "../commons/icon-button";
import { CloseIcon } from "../icons";
import { Link } from "react-router-dom";

export default function ShareModal({ isOpen, setIsOpen }) {
  const closeModal = () => setIsOpen(false);

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-sm transform overflow-hidden rounded-lg bg-white p-2 pb-6 text-left align-middle shadow-xl transition-all">
                <div className="flex justify-end">
                  <IconButton
                    variant="ghost"
                    onClick={closeModal}
                    icon={<CloseIcon />}
                    description="Close modal"
                    className="w-5 h-5 p-0 rounded-md"
                  />
                </div>
                <div className="px-6">
                  <Dialog.Title
                    as="h3"
                    className="font-semibold text-base sm:text-xl mb-4"
                  >
                    Share on
                  </Dialog.Title>
                  <div className="flex flex-col gap-2">
                    <Link
                      to="https://facebook.com"
                      className="hover:text-green-100 hover:underline active:text-[#0a7965]"
                      target="_blank"
                    >
                      Facebook
                    </Link>
                    <Link
                      to="https://twitter.com"
                      className="hover:text-green-100 hover:underline active:text-[#0a7965]"
                      target="_blank"
                    >
                      Twitter
                    </Link>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
